import React, { createContext, useContext, ReactNode } from 'react';
import { usePageLoader } from '../hooks/usePageLoader';

interface PageLoaderContextType {
  isLoading: boolean;
  message: string;
  showLoader: (message?: string) => void;
  hideLoader: () => void;
  setLoaderMessage: (message: string) => void;
}

const PageLoaderContext = createContext<PageLoaderContextType | undefined>(undefined);

interface PageLoaderProviderProps {
  children: ReactNode;
}

export const PageLoaderProvider: React.FC<PageLoaderProviderProps> = ({ children }) => {
  const pageLoader = usePageLoader();

  return (
    <PageLoaderContext.Provider value={pageLoader}>
      {children}
    </PageLoaderContext.Provider>
  );
};

export const usePageLoaderContext = (): PageLoaderContextType => {
  const context = useContext(PageLoaderContext);
  if (context === undefined) {
    throw new Error('usePageLoaderContext must be used within a PageLoaderProvider');
  }
  return context;
};
